import { createFileRoute } from '@tanstack/react-router';
import { JourneysSqlSyncImportHandoff } from '@/pages/workspaces/journeys/integrations/sql-sync/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/** The legacy `/journeys/integrations/sql-sync/:type/:id/settings` URL: the embedded tab while the flag is off, a forward once it is on. */
function JourneysSqlSyncImportTabRoute() {
  const { type, sqlImportId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSqlSyncImportHandoff type={type} sqlImportId={sqlImportId} tab="settings" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings',
)({
  component: JourneysSqlSyncImportTabRoute,
});
